import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-netbernet-black text-netbernet-white">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-mokoto font-bold mb-4">
              <span className="text-netbernet-blue">Net</span>bernet
            </h3>
            <p className="text-gray-400 mb-4">
              A complete IT software & web services solutions provider based in Hyderabad.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61573052482435" className="text-gray-400 hover:text-netbernet-white transition-colors" target="_blank" 
              rel="noopener noreferrer"
              >
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-netbernet-white transition-colors" target="_blank" 
              rel="noopener noreferrer"
              >
                <FaTwitter size={20} />
              </a>
              <a href="https://www.linkedin.com/company/netbernet" className="text-gray-400 hover:text-netbernet-white transition-colors" target="_blank" 
              rel="noopener noreferrer"
              >
                <FaLinkedin size={20} />
              </a>
              <a href="https://www.instagram.com/netbernet/" className="text-gray-400 hover:text-netbernet-white transition-colors" target="_blank" 
              rel="noopener noreferrer"
              >
                <FaInstagram size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">Home</Link></li>
              <li><a href="#services" className="text-gray-400 hover:text-netbernet-white transition-colors">Services</a></li>
              <li><a href="#mission" className="text-gray-400 hover:text-netbernet-white transition-colors">About Us</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-netbernet-white transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-netbernet-white transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/erp-services" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">ERP Solutions</Link></li>
              <li><Link to="/services" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">Web Development</Link></li>
              <li><Link to="/services" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">Cloud Services</Link></li>
              <li><Link to="/services" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">SEO & Digital Marketing</Link></li>
              <li><Link to="/services" onClick={() => window.scrollTo(0, 0)} className="text-gray-400 hover:text-netbernet-white transition-colors">Mobile Apps</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <address className="text-gray-400 not-italic">
              <p className="mb-2">Ring Road, Pillar No. 102, Attapur, Hyderabad-500006, Telangana, India</p>
              <p className="mb-2">Phone: +91 630 131 5362<br/><p className="mb-2 pl-12 ml-1">+91 40 45126535</p></p>
              <p className="mb-2">Email: info@netbernet.com</p>
            </address>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Netbernet. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;